/**
 * ******************
 * CREDITS
 * ******************
 */

/**
 * Variables
 *
 * @type {string}
 */
var creditAccordion = document.getElementsByClassName('credits-accordion');
var creditHamburger = document.getElementsByClassName('credits__hamburger');
var creditButton = document.getElementsByClassName('credits__button');

creditButton[0].addEventListener('click', creditsToggleItem, false);

/**
 * Function creditsToggleItem
 *
 * Open submenu for credits
 */
function creditsToggleItem() {

    creditAccordion[0].classList.toggle("credits-accordion_close");
    creditHamburger[0].classList.toggle("animate");

    setTimeout(function() {
        window.scrollBy(0,100);
    }, 100);
}